import React from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider } from '@chakra-ui/react';

import App from './App';

// import 'normalize.css';
import "./style.scss";
import theme from './theme';

ReactDOM.render(
  <ChakraProvider theme={theme} resetCSS={true}>
    <App />
  </ChakraProvider>,
  document.getElementById('root')
);
